import { Markdown } from "@/components/ai/chat/Markdown";
import { cn } from "@/components/podkit/lib/cn";
import type { UserMessage } from "@/hooks/use-stream-conversation";
import { IconClock } from "central-icons/IconClock";
import { type FC } from "react";

export const UserMsg: FC<{
    message: UserMessage;
    isPending: boolean;
}> = ({ message, isPending }) => {
    return (
        // the class user-message is used within the markdown component to style some markdown elements differently when presented
        // inside a user message.
        <div
            className="user-message flex w-fit max-w-full gap-2 self-end"
            data-message-id={`${message.type}-${message.id}`}
        >
            <div
                className={cn(
                    "min-w-0 flex-1 rounded-xl border border-border-subtle bg-surface-muted px-3 py-2 text-base text-content-primary transition-opacity",
                    {
                        "opacity-50": isPending,
                    },
                )}
            >
                <div className="flex gap-2">
                    {isPending && <IconClock className="mt-[1px] shrink-0 text-content-primary" size="14" />}
                    <div className="flex min-w-0 flex-1 flex-col">
                        {message.fragments.map((fragment) => {
                            switch (fragment.type) {
                                case "text": {
                                    return <Markdown content={fragment.content} key={fragment.id} />;
                                }
                            }
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};
